import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateGroupState } from "./types";
import { IGroup } from "@/shared/api/groups";
import { RoleType, IUser } from "@/shared/api/users";
import { TargetType } from "@/shared/api/groups";

const initialState: UpdateGroupState = {
    isCreateGroupModalOpen: false,
    isDeleteGroupModalOpen: false,
    isGroupAccrualModalOpen: false,
    isVisibilityAclModalOpen: false,
    currentGroup: {
        id: ""
    },
    currentUser: null,
    visibilityAclSourceType: null,
    currentRole: "users",
    onDelete: null,
    onCreate: null,
    onAccrual: null,
    onVisibilityAclChange: null
}

interface OpenCreateGroupModalPayload {
    role: RoleType,
    onCreate?: () => void
}

interface OpenDeleteGroupModalPayload {
    data: Pick<IGroup, 'id'>,
    role: RoleType,
    onDelete?: () => void
}

interface OpenGroupAccrualModalPayload {
    data: Pick<IGroup, 'id'>,
    onAccrual?: () => void
}

interface OpenVisibilityAclModalPayload {
    data: Pick<IGroup, 'id'> | Pick<IUser, 'id'>,
    sourceType: TargetType,
    onVisibilityAclChange?: () => void
}

const updateGroupSlice = createSlice({
    name: 'updateGroup',
    initialState,
    reducers: {
        openDeleteGroupModal: (state, action: PayloadAction<OpenDeleteGroupModalPayload>) => {
            state.currentGroup = action.payload.data
            state.currentRole = action.payload.role
            state.isDeleteGroupModalOpen = true
            state.onDelete = action.payload.onDelete
        },
        closeDeleteGroupModal: (state) => {
            state.isDeleteGroupModalOpen = false
        },
        openGroupAccrualModal: (state, action: PayloadAction<OpenGroupAccrualModalPayload>) => {
            state.currentGroup = action.payload.data
            state.isGroupAccrualModalOpen = true
            state.onAccrual = action.payload.onAccrual
        },
        closeGroupAccrualModal: (state) => {
            state.isGroupAccrualModalOpen = false
        },
        openCreateGroupModal: (state, action: PayloadAction<OpenCreateGroupModalPayload>) => {
            state.isCreateGroupModalOpen = true
            state.onCreate = action.payload.onCreate
            state.currentRole = action.payload.role
        },
        closeCreateGroupModal: (state) => {
            state.isCreateGroupModalOpen = false
        },
        openVisibilityAclModal: (state, action: PayloadAction<OpenVisibilityAclModalPayload>) => {
            state.visibilityAclSourceType = action.payload.sourceType
            if (action.payload.sourceType === TargetType.GROUP) {
                state.currentGroup = action.payload.data as Pick<IGroup, 'id'>
                state.currentUser = null
            } else {
                state.currentUser = action.payload.data as Pick<IUser, 'id'>
                state.currentGroup = { id: "" }
            }
            state.isVisibilityAclModalOpen = true
            state.onVisibilityAclChange = action.payload.onVisibilityAclChange
        },
        closeVisibilityAclModal: (state) => {
            state.isVisibilityAclModalOpen = false
            state.currentUser = null
            state.visibilityAclSourceType = null
        }
    }
})

export default updateGroupSlice.reducer
export const { openCreateGroupModal, openGroupAccrualModal, closeGroupAccrualModal, openDeleteGroupModal, closeCreateGroupModal, closeDeleteGroupModal, openVisibilityAclModal, closeVisibilityAclModal } = updateGroupSlice.actions